import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  title: {
    color: theme.palette.common.white,
    fontSize: 28,
  },
  benefitBox: {
    backgroundColor: theme.palette.common.white,
    borderRadius: theme.spacing(2),
    paddingBottom: theme.spacing(1.5),
    width: 228,
    height: 220,

    '& img': {
      height: 80,
      width: 80,
      margin: theme.spacing(3, 0, 1),
    },

    '& hr': {
      margin: theme.spacing(0, 3, 1),
      backgroundColor: '#5F29CC',
    },
  },
  button: {
    padding: theme.spacing(1.5, 3),
    backgroundColor: 'transparent',
    border: '1px solid #FFFFFF',
    borderRadius: 35,
    textTransform: 'none',
    color: '#FFFFFF',
    fontWeight: 'bold',

    '&:hover': {
      backgroundColor: '#FFFFFF',
      color: '#5F29CC',
    },
  },
}));
